import { Listbox } from "@headlessui/react";
import { Button } from "@windmill/react-ui";
import React, { useState, useEffect } from "react";
import Hints from "../question/Question";
import BackButton from "./BackButton";
import OnBoardingContainer from "./onBoardingContainer";
import Logo from "../logo/Logo";

const staffStrengthOptions = [
  { id: 1, name: "1-10" },
  { id: 2, name: "11-50" },
  { id: 3, name: "51-100" },
  { id: 4, name: "101-500" },
  { id: 5, name: "500+" },
];

export default function AddBusinessName({
  onSubmit,
  setStoreData,
  isLoading,
  setStep,
  storeData,
}) {
  const [selectedStaffStrength, setSelectedStaffStrength] = useState(
    staffStrengthOptions[0]
  );
  const [businessName, setBusinessName] = useState(storeData?.name || "");

  const handleStaffStrengthChange = (value) => {
    setSelectedStaffStrength(value);
    setStoreData((prev) => ({
      ...prev,
      staff_strength: value.name,
    }));
  };

  const handleNameChange = (e) => {
    const newName = e.target.value;
    setBusinessName(newName);
    setStoreData((prev) => ({
      ...prev,
      name: newName,
    }));
  };

  useEffect(() => {
    if (!storeData?.staff_strength && selectedStaffStrength?.name) {
      setStoreData((prev) => ({
        ...prev,
        staff_strength: selectedStaffStrength.name,
      }));
    }
  }, [selectedStaffStrength]);

  // If storeData.name changes externally, update the local state
  useEffect(() => {
    if (storeData?.name !== businessName) {
      setBusinessName(storeData?.name || "");
    }
  }, [storeData?.name]);

  return (
    <div>
      <div className="min-h-screen bg-green-50 flex justify-center items-center px-3">
        <div className="container mx-auto">
          <div className="max-w-lg mx-auto ">
            <div className="w-full">
              <OnBoardingContainer>
                <div className="p-6 lg:p-8 lg:px-10">
                  <Logo />
                  <h1 className="font-medium text-lg mt-6">Team Details</h1>
                  <p className="text-xs mt-1 text-gray-500 w-10/12">
                    Fill in your organization, team or department details.
                  </p>
                  <fieldset>
                    <div className="flex flex-col gap-1 text-left mt-6">
                      <label className="text-sm font-medium leading-tight">
                        Team name
                      </label>
                      <Hints hint="Input the name your organization, team, or department." />
                      <div className="col-span-8 sm:col-span-4">
                        <input
                          className="w-full focus:border-green-50 text-sm border focus:shadow-md px-3 h-10 focus:outline-none rounded"
                          onChange={handleNameChange}
                          value={businessName}
                          name="name"
                          type="text"
                          placeholder="Enter a team name"
                          required={true}
                        />
                      </div>
                    </div>

                    {/* Dropdown for Staff Strength */}
                    <div className="flex flex-col gap-1 text-left mt-6">
                      <label className="text-sm font-medium leading-tight">
                        Team Size
                      </label>
                      <p className="text-xs text-gray-500">
                        Select the number of people in your team, department, or
                        organization.
                      </p>
                      <Listbox
                        value={selectedStaffStrength}
                        onChange={handleStaffStrengthChange}
                      >
                        <div className="relative">
                          <Listbox.Button className="w-full text-left focus:border-green-50 text-sm border focus:shadow-md px-3 h-10 focus:outline-none rounded">
                            {selectedStaffStrength.name}
                          </Listbox.Button>
                          <Listbox.Options className="absolute z-10 w-full mt-1 bg-white shadow-lg rounded-md py-1 text-base leading-6">
                            {staffStrengthOptions.map((option) => (
                              <Listbox.Option
                                key={option.id}
                                value={option}
                                className={({ active }) =>
                                  `cursor-pointer select-none relative py-2 px-4 ${
                                    active ? "bg-green-100" : "text-gray-900"
                                  }`
                                }
                              >
                                {option.name}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </div>
                      </Listbox>
                    </div>

                    <div className="mt-5 w-full mx-auto flex justify-between">
                      <BackButton setStep={setStep} />
                      <Button
                        disabled={isLoading || !businessName.trim()}
                        onClick={onSubmit}
                        className="lg:px-12 px-6 my-6"
                        style={{ borderRadius: "4px" }}
                      >
                        Submit
                      </Button>
                    </div>
                  </fieldset>
                </div>
              </OnBoardingContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
